// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Compact static 3D info box */
.cycletime-box {
  position: relative;
  display: inline-block;
  background: white;
  border: 2px solid hsl(145, 63%, 42%);
  border-radius: 8px;
  padding: 4px 12px;        
  color: hsl(0, 0%, 2%);
  font-weight: 600;
  letter-spacing: 0.3px;
  font-size: 0.9rem;        
  box-shadow:0 2px 0 hsl(145, 63%, 42%);
  transform: translateY(-1px);
  transition: all 0.2s ease-in-out;
  white-space: nowrap;       
  min-width: -moz-fit-content;       
  min-width: fit-content;
}

.cycletime-box span {
  display: inline-block;
}


`, "",{"version":3,"sources":["webpack://./src/app/Pages/CycleTime/partcycletime.css"],"names":[],"mappings":"AAAA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;EACjB,oCAAoC;EACpC,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;EACjB,qCAAqC;EACrC,2BAA2B;EAC3B,gCAAgC;EAChC,mBAAmB;EACnB,2BAAsB;EAAtB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB","sourcesContent":["/* Compact static 3D info box */\n.cycletime-box {\n  position: relative;\n  display: inline-block;\n  background: white;\n  border: 2px solid hsl(145, 63%, 42%);\n  border-radius: 8px;\n  padding: 4px 12px;        \n  color: hsl(0, 0%, 2%);\n  font-weight: 600;\n  letter-spacing: 0.3px;\n  font-size: 0.9rem;        \n  box-shadow:0 2px 0 hsl(145, 63%, 42%);\n  transform: translateY(-1px);\n  transition: all 0.2s ease-in-out;\n  white-space: nowrap;       \n  min-width: fit-content;\n}\n\n.cycletime-box span {\n  display: inline-block;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
